module.exports = __webpack_public_path__ + "static/media/login-bg.a72e71b7.webp";